module.exports = __webpack_public_path__ + "static/media/logo.ce023529.png";